module.exports = __webpack_public_path__ + "img/main-03-02.77a85fea.png";